import React from 'react';
import { Phone, Send } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { companyData } from '../data';

export default function StickyMobileContact() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleContactClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/kontakt') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/kontakt');
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-[#111111]/95 border-t border-orange-500/20 backdrop-blur-md shadow-2xl px-4 py-3 flex gap-3">
      {/* Call Button */}
      <a
        href={`tel:${companyData.phoneRaw}`}
        className="flex-1 flex items-center justify-center gap-2 bg-[#1a1a1a] border border-gray-800 hover:bg-gray-900 text-white py-3 rounded-none text-sm font-bold uppercase tracking-wider transition-colors"
      >
        <Phone className="w-4 h-4 text-orange-500" />
        <span>Ring nu</span>
      </a>

      {/* Quote / Contact Button */}
      <a
        href="/kontakt"
        onClick={handleContactClick}
        className="flex-1 flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-none text-sm font-bold uppercase tracking-wider transition-colors"
      >
        <Send className="w-4 h-4" />
        <span>Få tilbud</span>
      </a>
    </div>
  );
}
